.page {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    overflow: hidden;
    view-transition-name: content-page;

    /* Compensate for the right panel (420px) vs the left sidebar (up to 280px)
       so the article column's center aligns with the viewport center. */
    @container (min-width: $mantine-breakpoint-sm) {
        padding-left: 140px;
    }
}

.sidebar {
    display: none;
    width: clamp(180px, 20vw, 280px);
    flex-shrink: 0;
    padding: var(--mantine-spacing-md);
    padding-top: calc(28px + var(--mantine-spacing-md) * 2);
    overflow-y: auto;
    height: 100%;
    scrollbar-width: none;

    @container (min-width: $mantine-breakpoint-sm) {
        display: block;
    }
}

.onThisPage {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: var(--dib-light-blue);
    flex-shrink: 0;
    border-left: 1px solid var(--mantine-color-gneis-1);
    transition:
        width 0.2s ease,
        flex-basis 0.2s ease;
}

.onThisPageCollapsed {
    overflow: visible;
}

.onThisPageMobile {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 300;
}

.onThisPageContent {
    height: 100%;
    overflow-y: auto;
    flex-shrink: 0;
    padding: var(--mantine-spacing-xl);
    box-sizing: border-box;
    scrollbar-width: none;
    transition: transform 0.2s ease-in-out;
    width: 420px;
    min-width: 420px;

    .onThisPageCollapsed & {
        transform: translateX(100%);
    }
}

.sidebarToggle {
    position: absolute;
    top: var(--mantine-spacing-md);
    right: var(--mantine-spacing-xl);
    z-index: 11;

    .onThisPageCollapsed & {
        right: auto;
        left: -40px;
    }
}

.article {
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
    scroll-behavior: smooth;
    scrollbar-color: var(--mantine-color-gray-4) var(--mantine-color-gray-1);
    scrollbar-width: thin;
    scroll-timeline: --page-scroll block;
}

.articleInner {
    max-width: 48rem;
    margin: 0 auto;
    padding: var(--mantine-spacing-lg);
    margin-bottom: 50vh; /* Makes the CSS scroll spy work on the last (parent) toc item */

    @container (min-width: $mantine-breakpoint-sm) {
        padding: var(--mantine-spacing-xl);
    }
}

.onThisPageTitle {
    text-transform: uppercase;
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    color: var(--mantine-color-gneis-7);
    letter-spacing: 0.05em;
    margin-bottom: var(--mantine-spacing-sm);
}

.sectionTitle {
    margin-top: var(--mantine-spacing-xl);
}

.subsectionTitle {
    margin-top: var(--mantine-spacing-lg);
}

/* ========================================
 * Status messages — error, empty, access denied
 * ======================================== */

.statusMessage {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    text-align: center;
}

.statusTitle {
    font-size: clamp(1.25rem, 2.5vw, 1.5rem);
    font-weight: 400;
    letter-spacing: -0.02em;
    color: var(--mantine-color-gneis-7);
    line-height: 1.35;
    max-width: 32ch;
}

.statusDetail {
    font-size: var(--mantine-font-size-sm);
    color: var(--mantine-color-gneis-5);
    max-width: 40ch;
    margin-top: var(--mantine-spacing-xs);
}
